import { CheckCircle, Star } from "lucide-react";
import { AnimatedText } from "../components/shared/AnimatedText";
import { AnimatedBlock } from "../components/shared/AnimatedBlock";
import { AnimatedListItem } from "../components/shared/AnimatedListItem";
import { ABOUT_HIGHLIGHTS_I18N } from "../data/config";

export function AboutSection({ t, lang }) {
  return (
    <section id="about" className="bg-gray-50 py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-start">
          <div className="space-y-8">
            <div>
              <AnimatedText text={t.about.title} tag="h2" className="text-4xl md:text-5xl font-black text-blue-900 mb-4" />
              <AnimatedText text={t.about.companyTitle} tag="h3" delay={100} className="text-2xl font-bold text-gray-900 mb-4" />
              <AnimatedText text={t.about.desc} tag="p" delay={150} className="text-lg text-gray-700 leading-relaxed mb-6" />
              <ul className="space-y-3">
                {(ABOUT_HIGHLIGHTS_I18N[lang] || ABOUT_HIGHLIGHTS_I18N.en).map((item, idx) => (
                  <AnimatedListItem key={item} delay={idx * 80}>
                    <div className="flex items-start gap-3">
                      <CheckCircle className="w-5 h-5 mt-0.5 text-green-500 flex-shrink-0" />
                      <span className="text-lg font-medium text-gray-800">{item}</span>
                    </div>
                  </AnimatedListItem>
                ))}
              </ul>
            </div>
          </div>
          <div className="space-y-6">
            <AnimatedBlock delay={0} className="rounded-2xl border border-gray-200 p-8 shadow-lg">
              <AnimatedText text={t.about.howTitle} tag="h4" className="text-xl font-bold text-gray-900 mb-4" />
              <AnimatedText text={t.about.howDesc1} tag="p" delay={80} className="text-gray-700 leading-relaxed mb-4" />
              <AnimatedText text={t.about.howDesc2} tag="p" delay={160} className="text-gray-700 leading-relaxed" />
            </AnimatedBlock>
            <AnimatedBlock delay={100} className="rounded-2xl border border-gray-200 p-8 shadow-lg">
              <AnimatedText text={t.about.careerTitle} tag="h4" className="text-xl font-bold text-gray-900 mb-4" />
              <ul className="space-y-3">
                {t.about.careerItems.map((item, idx) => (
                  <AnimatedListItem key={item} delay={idx * 80}>
                    <div className="flex items-start gap-3">
                      <Star className="w-4 h-4 mt-1 text-[#F08232] flex-shrink-0" />
                      <span className="text-gray-700">{item}</span>
                    </div>
                  </AnimatedListItem>
                ))}
              </ul>
            </AnimatedBlock>
          </div>
        </div>
      </div>
    </section>
  );
}
